import { memo } from "react"
import { Container, Box, HStack } from "@chakra-ui/react"
import { Proposition } from "./Proposition"

const UniqueSellingProposition: React.FC<GatsbyTypes.SanitySectionUniqueSellingProposition> = ({ bgColor, propositions }) => {
  const hasPropositions = !!propositions?.length
  if (!hasPropositions) return null

  return (
    <Box as="section" bg={bgColor} py={1.5} textTransform="uppercase">
      <Container>
        <HStack wrap="wrap" spacing={[3, 3, 12]} justifyContent="center">
          {propositions?.map((proposition: any) => (
            <Proposition key={proposition?._key} {...proposition} />
          ))}
        </HStack>
      </Container>
    </Box>
  )
}

export default memo(UniqueSellingProposition)
